var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"skeleton-grid"},_vm._l((_vm.count),function(i){return _c('div',{key:i,staticClass:"skeleton-card"},[_c('div',{staticClass:"skeleton-line w-60"}),_c('div',{staticClass:"skeleton-line w-80"}),_c('div',{staticClass:"skeleton-line w-40"})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }